// extracted by mini-css-extract-plugin
export default {"cls1":"FocusedNav-cls1__iN","cls2":"FocusedNav-cls2__Sx FocusedNav-cls1__iN","useGrid":"FocusedNav-useGrid__mV"};